import { createSlice } from "@reduxjs/toolkit";

interface CompetitorAnalysisReportInitialStateModel {
  filter:any;
}
const CompetitorAnalysisReportInitialState: CompetitorAnalysisReportInitialStateModel = {
  filter:{
    PageIndex:1,
    PageSize:-1,
  

  }
};

const competitorAnalysisReportSlice = createSlice({
  name: "CompetitorAnalysisReportSlice ",
  initialState: CompetitorAnalysisReportInitialState,
  reducers: {
    handleSetCompetitorAnalysisReportFilter: (state, action) => {
      state.filter = action.payload.filter;
    },
    handleResetCompetitorAnalysisReportFitler: (state, ) => {
      state.filter = {
        PageIndex:1,
        PageSize:-1,
        
      };
    },
  },
});

export const {
  handleSetCompetitorAnalysisReportFilter,
  handleResetCompetitorAnalysisReportFitler,
} = competitorAnalysisReportSlice.actions;
export default competitorAnalysisReportSlice;
